// Import the functions you need from the SDKs you need

// TODO: Add SDKs for Firebase products that you want to use

// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration

const config = {

  apiKey: "AIzaSyBsupOB1m8df8ufSfSApnEM7BK2Y629bTM",

  authDomain: "vue-datatable-91549.firebaseapp.com",

  databaseURL: "https://vue-datatable-91549.firebaseio.com",

  projectId: "vue-datatable-91549",

  storageBucket: "vue-datatable-91549.appspot.com",

  messagingSenderId: "1038589655256",

  appId: "1:1038589655256:web:984804ac79681a04"

};


// Initialize Firebase

export default config;